function escapeRegex (val) {
  const regexp = new RegExp("(\\" +
    [ "/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^", "-" ]
      .join("|\\") + ")", "g");

  return val.replace(regexp, "\\$1");
}

function createSearchRegexp (search, regex, smart, caseInsensitive) {
  search = regex
    ? search
    : escapeRegex(search);

  if (smart) {
    /* For smart filtering we want to allow the search to work regardless of
    * word order. We also want double quoted text to be preserved, so word
    * order is important - a la google. So this is what we want to
    * generate:
    *
    * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
    */

    var a = (search.match(/"[^"]+"|[^ ]+/g) || [""]).map(function (word) {
      if (word.charAt(0) === "\"") {
        var m = word.match(/^"(.*)"$/);
        word = m ? m[1] : word;
      }

      return word.replace("\"", "");
    });

    search = "^(?=.*?" + a.join(")(?=.*?") + ").*$";
  }

  return new RegExp(search, caseInsensitive ? "i" : "");
}

export default createSearchRegexp;
